<template>
  <div id="ask-question">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section1">
        <div class="title">我要提问</div>
        <button class="button" @click="expertClick">专家招募</button>
      </div>
      <div class="section2">
        <div class="input-box">
          <span>手机号</span>
          <input placeholder="(必填项）请输入手机号" type="text" maxlength="11" v-model="phone" v-on:focus="focus()" v-on:blur="blur()" oninput="value=value.replace(/[^\d]/g,'')" />
        </div>
        <div class="input-box" v-on:click="selectQuestionClick">
          <span>问题类型</span>
          <input placeholder="(必填项）未选择" v-model="category_name" readonly />
          <div></div>
        </div>
        <div class="input-box textarea-box">
          <span>问题标题</span>
          <textarea placeholder="(必填项）请输入问题标题(50字内)" maxlength="50" v-model="title" v-on:focus="focus()" v-on:blur="blur()"></textarea>
        </div>
        <div class="input-box textarea-box">
          <span>问题内容</span>
          <textarea placeholder="(必填项）请输入问题内容(500字内)" maxlength="500" v-model="content" v-on:focus="focus()" v-on:blur="blur()"></textarea>
        </div>
        <div class="input-box" v-on:click="selectAddressClick">
          <span>所在地</span>
          <input placeholder="(必填项）未选择" v-model="address" readonly="readonly" unselectable="on" onfocus="this.blur()" />
          <div></div>
        </div>
      </div>
      <div class="section3">
        <div class="title">补充说明</div>
        <div class="tip">( 非必填项，最多可上传3张照片，请保证图片的清晰)</div>
        <div class="imgbox">
          <div class="img-box" v-for="(value, index) in 6" :key="index" v-show='imgUrls.length >= index'>
            <input type="file" @change="imageClick($event,index)" accept="*.jpg,*.png,*.jpeg" />
            <img :id="forId(index)" :src="emptyImg" />
            <div class="img-del" v-on:click='delImg(index)' v-show='imgUrls.length > index'></div>
          </div>
        </div>
      </div>
      <div class="section4">
        <div class="title">问题设置</div>
        <div class="check-box box1" v-on:click='messageClick'>
          <img id='msgImg' src="../assets/radio_n.png" />
          <span>收到回答短信通知我</span>
        </div>
        <div class="check-box box2" v-on:click='readClick'>
          <img id='readImg' src="../assets/radio_n.png" />
          <span>其他人可看到我的提问</span>
        </div>
      </div>
      <div class="section5" id="section5Box">
        <img id='ruleImg'  @click='ruleReadClick' src="../assets/radio_n.png" />
        <div class="tip">我已阅读<div @click='ruleClick'>咨询规则</div></div>
        <button class="submit" @click='submitClick' :style="{backgroundColor:activeStyle}">提交</button>
      </div>
    </div>
    <!--  地址选择  -->
    <AreaView :show="showAddress" @selectedArea="selectedArea"></AreaView>
    <!-- 问题类型 -->
    <SPicker :show="showSPicker" type="6" @selectedSPicker="selectedSPicker"></SPicker>
    <!-- 成功弹窗 -->
    <SuccessView :show="showSuccessView" type="1" @successViewClick="successViewClick"></SuccessView>
  </div>
</template>

<script>
import wxShare from '../wx/weixin.js'
import { Toast } from 'mint-ui'
import AreaView from '../components/area-view'
import SPicker from '../components/single-picker'
import SuccessView from '../components/success-view'

import mainHeader from '../view/header'
import mainFooter from '../view/footer'

export default{
  inject: ['reload'], // 界面刷新
  data () {
    return {
      showPop: false,
      showSPicker: false,
      showAddress: false,
      showSuccessView: false,
      emptyImg: require('../assets/empty.png'),
      msgImg_n: require('../assets/radio_n.png'),
      msgImg_s: require('../assets/radio_s.png'),
      isRule: 0,
      isMessage: 0,
      phone: '',
      category_id: '',
      category_name: '',
      title: '',
      content: '',
      province: '',
      city: '',
      area: '',
      address: '',
      imgUrls: [],
      isRead: 0,
      // isActive: false,
      activeStyle: '#FECDCD'
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
    },
    blur: function () {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        document.getElementById('section5Box').style.display = 'block'
      }
    },
    focus: function () {
      if (!this.utils.isIphone()) {
        document.getElementById('section5Box').style.display = 'none'
      }
    },
    forId: function (index) {
      return 'img-box' + index
    },
    expertClick: function () {
      this.$router.push({path: 'expert-recruit', query: {}})
    },
    selectQuestionClick: function () {
      this.showSPicker = true
    },
    selectedSPicker: function (value) {
      this.showSPicker = false
      if (value === '') {
        return
      }
      this.category_id = value.id
      this.category_name = value.name
    },
    selectAddressClick: function () {
      this.showAddress = true
    },
    selectedArea: function (province, city, area, code) {
      this.showAddress = false
      if (province.length <= 0) {
        return
      }
      this.province = province
      this.city = city
      this.area = area
      this.address = province + ' ' + city + ' ' + area
    },
    imageClick: function (e, index) {
      if (this.utils.isImageFile(e) === false) {
        return
      }
      this.uploadImage(e, index)
    },
    uploadImage: function (file, index) {
      var _this = this
      // 上传图片
      this.utils.uploadImage(file, function (response) {
        Toast('上传图片成功')
        let imgUrl = response
        console.log('图片--------' + imgUrl)
        document.getElementById('img-box' + index).src = 'http://cdn.zxzx119.com/' + imgUrl

        if ((_this.imgUrls.length <= index)) {
          _this.imgUrls.push(imgUrl)
        }
        _this.imgUrls[index] = imgUrl
      })
    },
    delImg: function (index) {
      this.imgUrls.splice(index, 1)
      console.log(this.imgUrls.length)
      for (let i = 0; i < 6; i++) {
        document.getElementById('img-box' + i).src = this.emptyImg
      }
      console.log(this.imgUrls.length)
      for (let i = 0; i < this.imgUrls.length; i++) {
        document.getElementById('img-box' + i).src = 'http://cdn.zxzx119.com/' + this.imgUrls[i]
      }
    },
    messageClick: function () {
      this.checkQuestionSet(0)
      if (this.isMessage === 0) {
        document.getElementById('msgImg').src = this.msgImg_s
        this.isMessage = 1
      } else {
        document.getElementById('msgImg').src = this.msgImg_n
        this.isMessage = 0
      }
    },
    readClick: function () {
      this.checkQuestionSet(1)
      if (this.isRead === 0) {
        document.getElementById('readImg').src = this.msgImg_s
        this.isRead = 1
      } else {
        document.getElementById('readImg').src = this.msgImg_n
        this.isRead = 0
      }
    },
    checkQuestionSet: function (index) {
      if (index === 0) {
        this.isRead = 0
        document.getElementById('readImg').src = this.msgImg_n
      } else {
        this.isMessage = 0
        document.getElementById('msgImg').src = this.msgImg_n
      }
    },
    ruleReadClick: function () {
      if (this.isRule === 0) {
        document.getElementById('ruleImg').src = this.msgImg_s
        this.isRule = 1
      } else {
        document.getElementById('ruleImg').src = this.msgImg_n
        this.isRule = 0
      }
    },
    ruleClick: function () {
      // 跳转咨询 规则
      window.location.href = 'http://cdn.zxzx119.com/345346348603034053468.pdf'
    },
    checkParam: function () {
      if (this.phone.length <= 0) {
        Toast('请输入联系方式')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入联系方式')
        return false
      }
      if (this.category_id.length <= 0) {
        Toast('请选择问题类型')
        return false
      }
      if (this.title.length <= 0) {
        Toast('请输入标题')
        return false
      }
      if (this.content.length <= 0) {
        Toast('请输入问题内容')
        return false
      }
      return true
    },
    submitClick: function () {
      var param = {
        user_id: '',
        phone: this.phone,
        content: this.title,
        describe: this.content,
        category_id: this.category_id,
        province: this.province,
        city: this.city,
        area: this.area,
        is_sms: this.isMessage,
        others_read: this.isRead,
        imgs: this.imgUrls.join(','),
        issue_type : 1
      }
      console.log(param)

      if (this.checkParam() === false) return

      var _this = this
      this.utils.POST(this.accountUrl + '/issue/submitIssue', param, function (response) {
        if (response.code === 0) {
          _this.showSuccessView = true
        }
      })
    },
    successViewClick: function () {
      this.showSuccessView = false
      this.reload()
    }
  },
  components: {
    mainHeader,
    mainFooter,
    SPicker,
    AreaView,
    SuccessView
  },
  watch: {
    isActive: function (val) {
      if (val === true) {
        this.activeStyle = '#C41335'
      } else {
        this.activeStyle = '#FECDCD'
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.phone.length > 0 && this.category_id > 0 && this.title.length > 0 &&
        this.content.length > 0 && this.province.length > 0 && this.isRule >= 1) {
        return true
      }
      return false
    }
  },
  mounted () {
    // 微信 分享
    wxShare.wxRegister('在线提问，为你解忧', '写出您的消防问题，数百位行业专家在线答疑', 'http://cdn.zxzx119.com/4689248674381824')
    // 登录状态
    let isLogin = localStorage.getItem('isLogin')
    if (isLogin === '0') {
      console.log('登录===' + isLogin)
      Toast('请先登录，再提交问题！')
    }
  }
}

</script>

<style scoped>
.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper{
  background-color: #F6F6F6;
  background-color: #FFEECC;
  background-color: #ededed;
  margin-top: 55px;
  padding-bottom: 70px;
}
.section1{
  position: relative;
  width: 100%;
  height: 130px;
  background-image: url(../assets/ask_banner.png);
  background-size: cover;
  background-position: center center;
}
.section1 .title{
  position: absolute;
  left: 20px;
  top: 45px;
  width: 96px;
  height: 40px;
  line-height: 40px;
  font-size: 19px;
  color: #000000;
  font-weight: bold;
}

.section1 .button{
  position: absolute;
  right: 15px;
  top: 45px;
  width: 96px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #FFFFFF;
  background-color: #C41335;
  border-radius: 2px;
}
.section2{
  position: relative;
  width: 100%;
  height: 345px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  border-bottom: #ededed solid 10px;
}
.section2 .input-box{
  position: relative;
  width: 100%;
  height: 55px;
  line-height: 55px;
  box-sizing: border-box;
  border-bottom: #eeeeee solid 1px;
}
.section2 .textarea-box{
  height: 85px;
}
.section2 .input-box span{
  padding-left: 15px;
  width: 100px;
  font-size:15px;
  color: #323232;
}
.section2 .input-box input{
  position: absolute;
  top: 10px;
  left: 100px;
  width: calc(100% - 125px);
  height: 34px;
  line-height: 34px;
  font-size:15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
  /*background-color: antiquewhite;*/
}
.section2 .input-box textarea{
  position: absolute;
  top: 15px;
  left: 100px;
  width: calc(100% - 125px);
  height: 65px;
  line-height: 25px;
  font-size:15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
}
.section2 .input-box div{
  position: absolute;
  left: calc(100% - 20px);
  top: 22px;
  width: 6px;
  height: 10px;
  background-image: url(../assets/next.png);
  background-size: cover;
  background-position: center center;
}
.section3{
  position: relative;
  width: 100%;
  height: 150px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  border-bottom: #ededed solid 10px;
}
.section3 .title{
  position: relative;
  margin-left: 15px;
  padding-top: 10px;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  color: #323232;
}
.section3 .tip{
  position: relative;
  top: 10px;
  margin-left: 15px;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #bebebe;
}
.section3 .imgbox{
  position: relative;
  top: 23px;
  width: calc(100% - 30px);
}
.section3 .imgbox .img-box{
  position: relative;
  margin-left: 5px;
  left: 5px;
  float: left;
  width: 50px;
  height: 50px;
  background-color: #F6F6F6;
  background-image: url(../assets/addphoto.png);
  background-size: cover;
  background-position: center center;
}
.section3 .imgbox .img-box img{
  /*position: absolute;*/
  width: 50px;
  height: 50px;
  object-fit: cover;

  border-radius: 5px;
}
.section3 .imgbox .img-box input{
  position: absolute;
  width: 50px;
  height: 50px;
  opacity: 0;
  /*background-color: #FFEECC;*/
}
.section3 .imgbox .img-box .img-del{
  position: absolute;
  top: 3px;
  right: 3px;
  width: 15px;
  height: 15px;
  background-image: url(../assets/icon-close.png);
  background-size: cover;
  background-position: center center;
  /*background-color: #FFEECC;*/
}
.section4{
  position: relative;
  width: 100%;
  height: 120px;
  background-color: #FFFFFF;
}
.section4 .title{
  position: absolute;
  left: 15px;
  top: 10px;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  color: #323232;
}
.section4 .check-box{
  position: absolute;
  top: 33px;
  left: 15px;
  width: calc(100% - 110px);
  height: 30px;
  font-size:15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
}
.section4 .check-box.box1{
  top: 33px;
}
.section4 .check-box.box2{
  top: 63px;
}
.section4 .check-box img{
  position: absolute;
  left: 0px;
  width: 22px;
  height: 22px;
  top: 14px;
  object-fit: cover;
}
.section4 .check-box span{
  position: absolute;
  left: 36px;
  line-height: 50px;
  font-size:15px;
  color: #000000;
}

.section5{
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 65px;
  line-height: 65px;
  background-color: #FFFFFF;
  border-top: solid #EEEEEE 1px;
  box-sizing: border-box;
}
.section5 img{
  position: absolute;
  left: 15px;
  width: 22px;
  height: 22px;
  top: 21px;
  object-fit: cover;
}
.section5 .tip{
  position: absolute;
  top: 10px;
  left: 50px;
  width: 250px;
  height: 45px;
  line-height: 45px;
  color: #333333;
  font-size: 14px;
}
.section5 .tip div{
  position: absolute;
  top: 0px;
  left: 58px;
  width: 100px;
  height: 45px;
  line-height: 45px;
  color: #C41335;
  font-size: 14px;
}
.section5 .submit{
  position: absolute;
  top: 10px;
  left: 190px;
  height: 45px;
  line-height: 45px;
  width: calc(100% - 205px );
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  background-color: #C41335;
  border-radius: 4px;
  z-index: 440;

}

</style>



// WEBPACK FOOTER //
// src/view/ask-question.vue